import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { BrowserRouter } from 'react-router-dom';
import { AppWord } from './value/AppConst';
import { appModeRepo } from './value/AppModel';

const gqlClient = new ApolloClient({
    cache: new InMemoryCache(),
    uri: "/graphql",
});

const root = ReactDOM.createRoot(document.getElementById('root'));
const urlNow = window.location.href;
const BoolTsr = urlNow.indexOf(AppWord.TSR_PRINT_SUB_URL) > 1 ? true : false;
appModeRepo({isTsrPrinter: BoolTsr, url: urlNow});

root.render(
    <React.StrictMode>
      <ApolloProvider client={gqlClient}>
        <BrowserRouter>
          <App/>
        </BrowserRouter>
      </ApolloProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
